export default class LogFeatures {

    constructor(router, auth) {
        this.router = router
        this.auth = auth
    }

    // Navigation.

    openLogs() {
        this.router.push({ name: 'dashboard-logs' })
    }

    openLog(registration, simulation) {
        this.router.push({ name: 'dashboard-log', params: {
            registrationId: registration.id,
            simulationId: simulation.id,
        } })
        return true
    }

    openSummary(registration, simulation) {
        this.router.push({ name: 'dashboard-log-summary', params: {
            registrationId: registration.id,
            simulationId: simulation.id,
        } })
        return true
    }

    
    // Capabilities.

    canEdit() {
        // Pilots can always edit notes for themselves.
        return true
    }

    // Local vs remote data mapping.
    
    mapData(registration) {
        return {
            id: registration ? registration.id : null,

            cohort: registration ? registration.cohort : null,
            cohort_id: registration ? registration.cohort_id : null,

            degree: registration ? registration.degree : null,
            degree_id: registration ? registration.degree_id : null,

            simulations: registration ? registration.simulations : null,
        }
    }

    unmapData(data) {
        return {...data}
    }
}
